/* ============================================================
   INFACTORY CORNERS — comportamiento de la landing
   Se carga SOLO en la plantilla page.corners.
   Sin dependencias externas. Todo el DOM que toca lleva prefijo .cn-
   ============================================================ */
(function () {
  'use strict';

  if (!document.querySelector('.cn')) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $$ = function (sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); };

  /* ----------------------------------------------------------
     1. Analítica
     No crea ni duplica píxeles: empuja el evento a lo que ya
     exista en el sitio (dataLayer de GTM/GA4, gtag, fbq) y
     dispara un CustomEvent para escucharlo desde otro lado.
     ---------------------------------------------------------- */
  function track(name, params) {
    var data = params || {};
    data.landing = 'corners';
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: 'corners_' + name };
      for (var k in data) { if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k]; }
      window.dataLayer.push(payload);
      if (typeof window.gtag === 'function') window.gtag('event', 'corners_' + name, data);
      if (typeof window.fbq === 'function') window.fbq('trackCustom', 'Corners_' + name, data);
      document.dispatchEvent(new CustomEvent('corners:' + name, { detail: data }));
    } catch (e) {
      /* la analítica nunca debe romper la página */
    }
  }
  window.cornersTrack = track;

  /* Delegación: cualquier elemento con data-cn-ev dispara su evento */
  document.addEventListener('click', function (ev) {
    var el = ev.target.closest ? ev.target.closest('[data-cn-ev]') : null;
    if (!el) return;
    track(el.getAttribute('data-cn-ev'), {
      label: el.getAttribute('data-cn-label') || (el.textContent || '').trim().slice(0, 60)
    });
  });

  /* ----------------------------------------------------------
     2. Nav interna
     a) Se coloca justo debajo del encabezado del sitio SI el
        encabezado está realmente pegado arriba. Hoy no lo está
        (el wrapper de sección de Shopify anula su position:sticky),
        así que en la práctica queda a ras del viewport. Medirlo en
        vez de asumirlo evita que se rompa si eso cambia.
     b) Aparece pasado el hero.
     c) Marca la sección activa.
     ---------------------------------------------------------- */
  var navBar = document.querySelector('.cn-nav');
  var heroEl = document.querySelector('[data-cn-hero]');
  var siteHeader = document.querySelector('.site-header');

  if (navBar && siteHeader) {
    var ticking = false;
    var placeNav = function () {
      ticking = false;
      var r = siteHeader.getBoundingClientRect();
      var top = r.bottom > 0 && r.top >= -1 ? Math.round(r.bottom) : 0;
      document.documentElement.style.setProperty('--cn-navtop', top + 'px');
    };
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(placeNav);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    placeNav();
  }

  if (navBar && 'IntersectionObserver' in window) {
    if (heroEl) {
      new IntersectionObserver(
        function (e) { navBar.classList.toggle('is-on', !e[0].isIntersecting); },
        { threshold: 0 }
      ).observe(heroEl);
    } else {
      navBar.classList.add('is-on');
    }
  } else if (navBar) {
    navBar.classList.add('is-on');
  }

  var navLinks = $$('.cn-nav__link[href^="#"]');
  if (navLinks.length && 'IntersectionObserver' in window) {
    var pairs = [];
    navLinks.forEach(function (a) {
      var anchor = document.getElementById(a.getAttribute('href').slice(1));
      if (!anchor) return;
      pairs.push({ link: a, sec: anchor.closest('.cn-sec') || anchor });
    });
    if (pairs.length) {
      var spy = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            var hit = null;
            for (var i = 0; i < pairs.length; i++) { if (pairs[i].sec === e.target) hit = pairs[i]; }
            if (!hit) return;
            navLinks.forEach(function (a) { a.classList.remove('is-active'); });
            hit.link.classList.add('is-active');
          });
        },
        { rootMargin: '-45% 0px -50% 0px', threshold: 0 }
      );
      pairs.forEach(function (p) { spy.observe(p.sec); });
    }
  }

  /* ----------------------------------------------------------
     3. FAQ — evento al abrir (una sola vez por pregunta)
     ---------------------------------------------------------- */
  $$('.cn-faq__item').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open || d.getAttribute('data-cn-seen')) return;
      d.setAttribute('data-cn-seen', '1');
      var q = d.querySelector('.cn-faq__q');
      track('faq_open', { label: q ? (q.textContent || '').trim().slice(0, 80) : '' });
    });
  });

  /* ----------------------------------------------------------
     4. Video Gallery — facade.
     El iframe se crea al clic: YouTube/Vimeo no cargan nada en
     el primer render y no hay autoplay de nada al abrir la página.
     ---------------------------------------------------------- */
  function swapIn(btn, node) {
    var frame = btn.closest('.cn-vg__frame');
    if (!frame) return null;
    track('video_play', { label: btn.getAttribute('data-cn-title') || '' });
    frame.innerHTML = '';
    frame.appendChild(node);
    return node;
  }

  $$('.cn-vg__play[data-cn-embed]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var src = btn.getAttribute('data-cn-embed');
      if (!src) return;
      var iframe = document.createElement('iframe');
      iframe.setAttribute('src', src);
      iframe.setAttribute('title', btn.getAttribute('data-cn-title') || 'Video');
      iframe.setAttribute('loading', 'lazy');
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      swapIn(btn, iframe);
    });
  });

  $$('.cn-vg__play[data-cn-video]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var src = btn.getAttribute('data-cn-video');
      if (!src) return;
      var v = document.createElement('video');
      v.setAttribute('src', src);
      v.setAttribute('controls', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('preload', 'metadata');
      if (swapIn(btn, v)) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  });

  var rail = document.querySelector('.cn-vg__rail');
  if (rail) {
    var railSeen = false;
    rail.addEventListener(
      'scroll',
      function () {
        if (railSeen) return;
        railSeen = true;
        track('video_scroll', {});
      },
      { passive: true }
    );
  }

  /* ----------------------------------------------------------
     5. Formulario — inicio (primer foco) y envío
     ---------------------------------------------------------- */
  var form = document.querySelector('form[data-cn-form]');
  if (form) {
    var started = false;
    form.addEventListener(
      'focusin',
      function () {
        if (started) return;
        started = true;
        track('form_start', {});
      },
      true
    );

    /* Espejo a la hoja de cálculo.
       NO se intercepta el submit: el form nativo de Shopify sigue su
       curso y el beacon viaja en paralelo. El receptor deduplica. */
    form.addEventListener('submit', function () {
      var plan = form.querySelector('[name="contact[Plan de interes]"]');
      track('form_submit', { label: plan ? plan.value : '' });

      var url = form.getAttribute('data-cn-webhook');
      if (!url) return;
      var hp = form.querySelector('[name="contact[website]"]');
      if (hp && hp.value) return;
      try {
        var payload = {};
        new FormData(form).forEach(function (v, k) {
          if (k.indexOf('contact[') !== 0) return;
          payload[k.slice(8, -1)] = typeof v === 'string' ? v : '';
        });
        payload.origen = 'landing-corners';
        payload.url = window.location.href;
        if (navigator.sendBeacon) {
          navigator.sendBeacon(url, new Blob([JSON.stringify(payload)], { type: 'text/plain;charset=UTF-8' }));
        }
      } catch (e) {
        /* si el espejo falla, el correo nativo ya salió */
      }
    });
  }

  /* ----------------------------------------------------------
     6. Barra sticky mobile
     Aparece pasado el hero; se esconde sobre el formulario,
     sobre el CTA final y sobre el pie, para no encimarse.
     ---------------------------------------------------------- */
  var bar = document.querySelector('.cn-sticky');
  if (bar && 'IntersectionObserver' in window) {
    var pastHero = false;
    var hits = [];

    var paint = function () { bar.classList.toggle('is-on', pastHero && hits.length === 0); };

    if (heroEl) {
      new IntersectionObserver(
        function (e) { pastHero = !e[0].isIntersecting; paint(); },
        { threshold: 0 }
      ).observe(heroEl);
    } else {
      pastHero = true;
    }

    var quiet = $$('[data-cn-quiet]');
    var footer = document.querySelector('.site-footer') || document.querySelector('footer');
    if (footer) quiet.push(footer);
    if (quiet.length) {
      var qo = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            var i = hits.indexOf(e.target);
            if (e.isIntersecting && i === -1) hits.push(e.target);
            if (!e.isIntersecting && i !== -1) hits.splice(i, 1);
          });
          paint();
        },
        { threshold: 0 }
      );
      quiet.forEach(function (q) { qo.observe(q); });
    }
    paint();
  }

  /* ----------------------------------------------------------
     7. Anclas suaves, respetando reduced-motion
     ---------------------------------------------------------- */
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest ? ev.target.closest('a[href^="#"]') : null;
    if (!a || !a.closest('.cn')) return;
    var id = a.getAttribute('href').slice(1);
    if (!id) return;
    var t = document.getElementById(id);
    if (!t) return;
    ev.preventDefault();
    t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    var sec = t.closest('.cn-sec') || t;
    sec.setAttribute('tabindex', '-1');
    setTimeout(function () { sec.focus({ preventScroll: true }); }, reduce ? 0 : 450);
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  });
})();
